export enum EAdminRoutes {
    Root = '/',
    Login = '/login',
    Dashboard = '/dashboard',
    Customers = '/customers',
    Patients = '/patients',
    Practices = '/practices',
    NotFoundException = '/404',
    Admins = '/admins',
}
